/**
 * Display formatters for the ROI calculator. Kept in one place so the component and its tests format
 * a number the same way (a test asserts a result equals `usd(computeRoi(...).noi)`). Null-tolerant
 * where the engine emits `null` — the sheet's "n/a" — so the UI never prints a fake 0 or NaN.
 */
const USD0 = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
})

/** Whole-dollar money for large figures (NOI, NPV, CapEx, cash flows). */
export const usd = (n: number): string => USD0.format(n)

/** Per-kWh money — 4 decimals, e.g. $0.5500. Cents-scale values need the precision. */
export const perKwh = (n: number): string => `$${n.toFixed(4)}`

/** Years to one decimal, or "n/a" when the engine could not solve it (NOI <= 0). */
export const years = (n: number | null): string => (n == null ? 'n/a' : `${n.toFixed(1)} yr`)

/** A rate (0.08 → "8.0%"), or "n/a" for an unsolvable IRR / undefined return. */
export const percent = (n: number | null): string =>
  n == null ? 'n/a' : `${(n * 100).toFixed(1)}%`
